import React from "react";

interface IconProps {
  alt?: string;
  width: string | number;
  height: string | number;
}

const CustomIcons: React.FC<IconProps> & {
  CandleStick: React.FC<IconProps>;
} & { Eth: React.FC<IconProps> } & { Btc: React.FC<IconProps> } = () => {
  return null;
};

CustomIcons.CandleStick = ({ alt, width, height }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 512 512"
      className="fill-primary"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M452 78.67H451.28V40C451.28 33.1 445.68 27.5 438.78 27.5C431.88 27.5 426.28 33.1 426.28 40V78.67H425.56C407.64 78.67 393.06 93.25 393.06 111.17V362.6C393.06 380.52 407.64 395.1 425.56 395.1H426.28V433.77C426.28 440.67 431.88 446.27 438.78 446.27C445.68 446.27 451.28 440.67 451.28 433.77V395.1H452C469.92 395.1 484.5 380.52 484.5 362.6V111.17C484.5 93.25 469.92 78.67 452 78.67ZM459.5 362.6C459.5 366.74 456.14 370.1 452 370.1H425.56C421.42 370.1 418.06 366.74 418.06 362.6V111.17C418.06 107.03 421.42 103.67 425.56 103.67H452C456.14 103.67 459.5 107.03 459.5 111.17V362.6ZM330.15 199.9H329.43V180.73C329.43 173.83 323.83 168.23 316.93 168.23C310.03 168.23 304.43 173.83 304.43 180.73V199.9H303.71C285.79 199.9 271.21 214.48 271.21 232.4V420.32C271.21 438.24 285.79 452.82 303.71 452.82H304.43V471.99C304.43 478.89 310.03 484.49 316.93 484.49C323.83 484.49 329.43 478.89 329.43 471.99V452.82H330.15C348.07 452.82 362.65 438.24 362.65 420.32V232.4C362.65 214.48 348.07 199.9 330.15 199.9ZM337.65 420.32C337.65 424.46 334.29 427.82 330.15 427.82H303.71C299.57 427.82 296.21 424.46 296.21 420.32V232.4C296.21 228.26 299.57 224.9 303.71 224.9H330.15C334.29 224.9 337.65 228.26 337.65 232.4V420.32ZM208.3 158.71H207.58V132.78C207.58 125.88 201.98 120.28 195.08 120.28C188.18 120.28 182.58 125.88 182.58 132.78V158.71H181.86C163.94 158.71 149.36 173.29 149.36 191.21V306.36C149.36 324.28 163.94 338.86 181.86 338.86H182.58V364.79C182.58 371.69 188.18 377.29 195.08 377.29C201.98 377.29 207.58 371.69 207.58 364.79V338.86H208.3C226.22 338.86 240.8 324.28 240.8 306.36V191.21C240.8 173.29 226.22 158.71 208.3 158.71ZM215.8 306.36C215.8 310.5 212.44 313.86 208.3 313.86H181.86C177.72 313.86 174.36 310.5 174.36 306.36V191.21C174.36 187.07 177.72 183.71 181.86 183.71H208.3C212.44 183.71 215.8 187.07 215.8 191.21V306.36ZM86.44 84.54H85.72V40C85.72 33.1 80.12 27.5 73.22 27.5C66.32 27.5 60.72 33.1 60.72 40V84.54H60C42.08 84.54 27.5 99.12 27.5 117.04V349.16C27.5 367.08 42.08 381.66 60 381.66H60.72V426.2C60.72 433.1 66.32 438.7 73.22 438.7C80.12 438.7 85.72 433.1 85.72 426.2V381.66H86.44C104.36 381.66 118.94 367.08 118.94 349.16V117.04C118.94 99.12 104.36 84.54 86.44 84.54ZM93.94 349.16C93.94 353.3 90.58 356.66 86.44 356.66H60C55.86 356.66 52.5 353.3 52.5 349.16V117.04C52.5 112.9 55.86 109.54 60 109.54H86.44C90.58 109.54 93.94 112.9 93.94 117.04V349.16Z" />
    </svg>
  );
};

CustomIcons.Eth = ({ alt = "eth", width, height }) => {
  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
      className={`content-center me-1 rounded-full flex items-center justify-center bg-[#5456DC]`}
    >
      <img className="h-4 w-auto" src="/assets/images/eth-logo.png" alt={alt} />
    </div>
  );
};

CustomIcons.Btc = ({ alt = "eth", width, height }) => {
  return (
    <div
      style={{
        width: `${width}px`,
        height: `${height}px`,
      }}
      className=" content-center me-1 rounded-full flex items-center justify-center"
    >
      <img
        className="h-4 w-auto"
        src="/assets/images/bitcoin-btc-logo.png"
        alt="Btc"
      />
    </div>
  );
};

export default CustomIcons;
